module.exports = __webpack_public_path__ + "src/assets/img/m-item1.d3ab8a8f.png";